export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_day_119.f4570c8d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};